import { useMemo, memo } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  BreadcrumbsContainer,
  Breadcrumbs,
  useHeroSnackbar,
  useTranslations,
} from '@uniqkey-frontend/shared-app';
import PageRouteEnum from '../../../../enums/PageRouteEnum';
import { useGetEmployeeAccountById } from '../../../../hooks/reactQuery';

interface IEmployeePageBreadcrumbsProps {
  employeeAccountId: string;
}

const EmployeePageBreadcrumbs = (props: IEmployeePageBreadcrumbsProps) => {
  const { employeeAccountId } = props;
  const { t } = useTranslations();
  const navigate = useNavigate();
  const { showError } = useHeroSnackbar();

  const { data: employeeAccount, isLoading } = useGetEmployeeAccountById(
    { employeeAccountId },
    {
      onError: () => {
        showError({ text: t('common.somethingWentWrong') });
        navigate(PageRouteEnum.Employees);
      },
    },
  );

  const breadcrumbsNodes = useMemo(() => {
    if (isLoading || !employeeAccount) {
      return [];
    }
    return [
      { title: t('navigation.employees'), onClick: () => navigate(PageRouteEnum.Employees) },
      { title: employeeAccount.email },
    ];
  }, [isLoading, employeeAccount, navigate, t]);

  return (
    <BreadcrumbsContainer>
      <Breadcrumbs
        nodes={breadcrumbsNodes}
        isLoading={isLoading}
      />
    </BreadcrumbsContainer>
  );
};

export default memo(EmployeePageBreadcrumbs);
